exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../node_modules/css-loader/index.js?minimize!./assets/css/main.css"), "");

// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-143026a4!./~/vue-loader/lib/selector.js?type=styles&index=0!./app/App.vue
// module id = 133
// module chunks = 0